import { isStaleChunkError } from "./is-stale-chunk-error";

/**
 * A lazy route keeps its failed import for the page's lifetime, so only a fresh document retries a stale chunk.
 * Offline, the reload waits for the next `online` event. The returned disposer cancels that pending reload.
 */
export function retryAfterError(
	error: unknown,
	reset: () => void,
	reload: () => void = () => window.location.reload(),
): () => void {
	if (!isStaleChunkError(error)) {
		reset();
		return () => undefined;
	}
	if (navigator.onLine !== false) {
		reload();
		return () => undefined;
	}
	const onOnline = () => reload();
	window.addEventListener("online", onOnline, { once: true });
	return () => window.removeEventListener("online", onOnline);
}
